import "@/lib/sentry/instrument"

import { createRoot } from "react-dom/client"

import App from "./App"
import { ErrorBoundary } from "./lib/sentry/error-boundary"

const root = createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)
